export const environment = {
  imagesUrl: "https://dhgfks2wjmlmy.cloudfront.net",
  logoutURL: "/oportunidades-laborales-26",
  apiUrl: "https://api2.columnis.com/090",
  candidateUri: "/recruitment/candidates/",
  interestAreasUri: "/recruitment/interest_areas",
  downloadMyCVUri: "/recruitment/download-my-cv",
  myApplicationsUri: "/recruitment/get-user-applications",
};
